import moment from 'moment'

export const newDateObject = (date) => moment(date)

export const formattedDateObject = (date, format) => {
  if (!date) return '—'
  const parsed = moment(date)
  return parsed.isValid() ? parsed.format(format) : '—'
}

export const isBefore = (a, b) => {
  // if the args are already MomentJS objects, no need to create new ones!
  const dateA = a.isBefore ? a : moment(a)
  const dateB = b.isBefore ? b : moment(b)
  return dateA.isBefore(dateB)
}

export const daysFromNow = (days) => {
  const now = moment()
  if (!days || typeof days !== 'number') {
    return now
  }
  if (days < 0) {
    return now.subtract(days, 'day')
  }
  return now.add(days, 'day')
}
